/**
 * The currencies the ledger knows, carrying the one property it needs: how
 * many minor units make a major unit. The scale decides what a stored
 * `bigint` *means* — JPY at 0 and MNT at 2 are different numbers for the same
 * nominal price — so it is validated at construction, not assumed.
 *
 * Extending the table is an entry here plus the migration that adds the row;
 * there is no runtime registration, because a currency is ISO 4217 and not
 * tenant data.
 */
import { raise } from "../errors/index.js";
function define(code, minorScale, mn, en) {
    return { code: code, minorScale, name: { mn, en } };
}
/**
 * MNT is the functional currency (Accounting Law art. 7.2). USD is what AWS,
 * Cloudflare and the app stores bill in (docs/22 §7). The rest are the pairs
 * Монголбанк publishes that a marketplace plausibly meets; two of them are
 * zero-decimal, which is the 100× trap the scale exists to catch.
 */
const TABLE = [
    define("MNT", 2, "Монгол төгрөг", "Mongolian tögrög"),
    define("USD", 2, "Америк доллар", "US dollar"),
    define("CNY", 2, "Хятад юань", "Chinese yuan"),
    define("EUR", 2, "Евро", "Euro"),
    define("RUB", 2, "Орос рубль", "Russian rouble"),
    define("JPY", 0, "Япон иен", "Japanese yen"),
    define("KRW", 0, "Солонгос вон", "South Korean won"),
];
const REGISTRY = new Map(TABLE.map((c) => [c.code, c]));
export function getCurrency(code) {
    const found = REGISTRY.get(code);
    if (!found)
        raise("UNKNOWN_CURRENCY", { code });
    return found;
}
export function currencyCode(code) {
    return getCurrency(code).code;
}
export function listCurrencies() {
    return TABLE;
}
/** The functional currency of every line in the general ledger. */
export const MNT = "MNT";
export const USD = "USD";
//# sourceMappingURL=currency.js.map